<script setup lang="ts">
import { RouterView } from 'vue-router';
import { useDarkMode } from 'shared/themes/composables/darkMode';
useDarkMode();

</script>

<template>
  <RouterView />
</template>


